import React, { useLayoutEffect } from "react";
import { Navigate } from "react-router-dom";
import storage from "../services/storage";
import { useDispatch } from "react-redux";
import { getUserDetails } from "../Store/api/auth";

const authGuard = (Element) => {
  return (props) => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("xAuthToken");
    const user = storage.get("user");

    useLayoutEffect(() => {
      if (user.role === "PROFESSOR" && user.status === "waiting") {
        dispatch(
          getUserDetails({
            userId: user._id,
            onSuccess: () => {},
            onError: () => {},
            onEnd: () => {},
          })
        );
      }
    }, [user?.status]);

    if (token && user) {
      return <Element {...props} />;
    } else {
      return <Navigate to="/" {...props} />;
    }
  };
};

export default authGuard;
